import React, { Component } from 'react'
import { onClientSide } from 'utils/utils'
import './VehicleDetails.scss'
import FavoriteDA from '@/components/FavoriteDA'
import CarDeliveryExtendedStamp from '@/modern/components/Stamps/ExtendedCarDelivery'
import CertifiedPurchaseHeader from '@/modern/components/CertifiedPurchase/Header'
import SellerRespondsFast from '@/modern/components/Stamps/SellerRespondsFast'

class VehicleDetailsBasicInformation extends Component {
  static handleHasLinkScroll() {
    if (onClientSide()) {
      document
        .getElementById('SimulationSantanderCompany')
        .scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  render() {
    const {
      id,
      IsElegibleVehicleInspection,
      trackingHandler,
      seal,
      isCarDelivery,
      isUnavailable,
      cardId,
      vehicleType,
      basicInformations,
      ad,
      isBlackFeirao,
      hasRespondsFast,
      hasMegaFair,
      children,
    } = this.props

    const hasThreeSeals = (isBlackFeirao || hasMegaFair) && isCarDelivery && hasRespondsFast
    
    return (
      <div className="VehicleDetails" id={id || ''}>
        <CertifiedPurchaseHeader
          theme="dark"
          shouldRender={IsElegibleVehicleInspection}
          trackingHandler={trackingHandler}
        />
        <div className="VehicleDetails__header">
          <div className={`VehicleDetails__header__top ${hasThreeSeals ? 'VehicleDetails__header__hasFairStamps' : ''}`}>
            <h1
              id="VehicleBasicInformationTitle"
              className="VehicleDetails__header__title"
            >
              {basicInformations.make}{' '}
              <strong>{basicInformations.model}</strong>
              <span
                id="VehicleBasicInformationDescription"
                className="VehicleDetails__header__description"
              >
                {basicInformations.description}
              </span>
            </h1>
            <div className="VehicleDetails__header__stamps">
              <SellerRespondsFast ad={ad} />
              {seal || ''}
              {isCarDelivery && <CarDeliveryExtendedStamp isDA />}
              <div className="VehicleDetails__header__favorite">
                {!isUnavailable && (
                  <FavoriteDA
                    id={cardId ? cardId.toString() : ''}
                    vehicleType={vehicleType}
                    details={ad}
                  />
                )}
              </div>
            </div>
          </div>
          {children || ''}
        </div>
      </div>
    )
  }
}
export default VehicleDetailsBasicInformation
